<script setup lang="ts">
defineProps<{
  block: TextBlock
}>()

const { styles } = useVariants('menuTextBlock')
</script>

<template>
  <div :class="styles.base()">
    <h2 v-if="block.title" :class="styles.title()">
      {{ block.title }}
    </h2>
    <p v-if="block.description" :class="styles.description()">
      {{ block.description }}
    </p>
  </div>
</template>
